import card1 from "../assets/profile.jpeg";
const Contact = () => {
  return (
    <section className="bg-[#fff9e6] py-24">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-16 items-center">

        {/* LEFT IMAGE CARD */}
        <div className="relative">
          <div className="border-4 border-[#9b6b91] rounded-2xl overflow-hidden">
            <img
              src={card1}
              alt="About"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Decorative swirl */}
          <div className="absolute -left-10 top-8 w-24 h-24 bg-[#b56b7a] rounded-full flex items-center justify-center">
            <span className="text-white text-3xl">💗</span>
          </div>
        </div>

        {/* RIGHT FORM */}
        <div>
          <h2 className="text-5xl font-serif text-[#8b6c8d] mb-10">
            Let’s talk.
          </h2>

          <form className="space-y-6">
            <div>
              <label className="block mb-2 text-[#b84b6d]">
                Your Name
              </label>
              <input
                type="text"
                className="w-full rounded-full bg-[#f3f0e5] px-6 py-4 focus:outline-none"
              />
            </div>

            <div>
              <label className="block mb-2 text-[#b84b6d]">
                Your Email
              </label>
              <input
                type="email"
                className="w-full rounded-full bg-[#f3f0e5] px-6 py-4 focus:outline-none"
              />
            </div>

            <div>
              <label className="block mb-2 text-[#b84b6d]">
                Subject
              </label>
              <input
                type="text"
                className="w-full rounded-full bg-[#f3f0e5] px-6 py-4 focus:outline-none"
              />
            </div>

            <div>
              <label className="block mb-2 text-[#b84b6d]">
                Message
              </label>
              <textarea
                rows="5"
                className="w-full rounded-3xl bg-[#f3f0e5] px-6 py-4 focus:outline-none resize-none"
              />
            </div>

            <button
              type="submit"
              className="w-full bg-[#a85050] text-yellow-300 py-4 rounded-full text-lg font-medium hover:bg-[#933f3f] transition"
            >
              submit
            </button>
          </form>
        </div>

      </div>
    </section>
  );
};

export default Contact
